// Auto-generated index of all GraphQL mutations
import { gql } from "@apollo/client";

// Import all mutation files
import addCompanyToTenantContent from "./addCompanyToTenant.graphql?raw";
import addCompanyContent from "./addCompany.graphql?raw";
import updateCompanyContent from "./updateCompany.graphql?raw";
import deleteCompanyContent from "./deleteCompany.graphql?raw";
import addCustomerUserContent from "./addCustomerUser.graphql?raw";
import addDataLimitContent from "./addDataLimit.graphql?raw";
import addDealContent from "./addDeal.graphql?raw";
import addMeterDataContent from "./addMeterData.graphql?raw";
import addModuleContent from "./addModule.graphql?raw";
import addPartnerContent from "./addPartner.graphql?raw";
import addRoleContent from "./addRole.graphql?raw";
import addSubscriptionFeatureContent from "./addSubscriptionFeature.graphql?raw";
import addSubscriptionPlanContent from "./addSubscriptionPlan.graphql?raw";
import addTenantContent from "./addTenant.graphql?raw";
import addUserByAdminContent from "./addUserByAdmin.graphql?raw";
import addUserToPartnerContent from "./addUserToPartner.graphql?raw";
import addUserToTenantContent from "./addUserToTenant.graphql?raw";
import changePasswordMutatiionContent from "./changePasswordMutatiion.graphql?raw";
import deleteAllNotificationsContent from "./deleteAllNotifications.graphql?raw";
import deleteDataLimitContent from "./deleteDataLimit.graphql?raw";
import deleteDealContent from "./deleteDeal.graphql?raw";
import deleteModuleContent from "./deleteModule.graphql?raw";
import deleteNotificationContent from "./deleteNotification.graphql?raw";
import deletePublicTokenContent from "./deletePublicToken.graphql?raw";
import deleteRoleContent from "./deleteRole.graphql?raw";
import deleteSubscriptionFeatureContent from "./deleteSubscriptionFeature.graphql?raw";
import deleteSubscriptionPlanContent from "./deleteSubscriptionPlan.graphql?raw";
import deleteTenantContent from "./deleteTenant.graphql?raw";
import deleteUserDocumentContent from "./deleteUserDocument.graphql?raw";
import deleteUsersCustomerAdminContent from "./deleteUsersCustomerAdmin.graphql?raw";
import forgotPasswordContent from "./forgotPassword.graphql?raw";
import generatePublicTokenContent from "./generatePublicToken.graphql?raw";
import loginContent from "./login.graphql?raw";
import loginAsContent from "./loginAs.graphql?raw";
import notifyNotificationContent from "./notifyNotification.graphql?raw";
import readAllNotificationsContent from "./readAllNotifications.graphql?raw";
import readNotificationContent from "./readNotification.graphql?raw";
import unreadNotificationContent from "./unreadNotification.graphql?raw";
import redirectStatsContent from "./redirectStats.graphql?raw";
import registerContent from "./register.graphql?raw";
import removeCompanyFromTenantContent from "./removeCompanyFromTenant.graphql?raw";
import removeUserFromPartnerContent from "./removeUserFromPartner.graphql?raw";
import removeUserFromTenantContent from "./removeUserFromTenant.graphql?raw";
import resetPasswordContent from "./resetPassword.graphql?raw";
import sendWelcomeEmailContent from "./sendWelcomeEmail.graphql?raw";
import updateCurrentUserProfileContent from "./updateCurrentUserProfile.graphql?raw";
import updateDataLimitContent from "./updateDataLimit.graphql?raw";
import updateDealContent from "./updateDeal.graphql?raw";
import updateModuleContent from "./updateModule.graphql?raw";
import updatePartnerContent from "./updatePartner.graphql?raw";
import updateRoleContent from "./updateRole.graphql?raw";
import updateRoleModulesContent from "./updateRoleModules.graphql?raw";
import updateSettingsContent from "./updateSettings.graphql?raw";
import updateSubscriptionFeatureContent from "./updateSubscriptionFeature.graphql?raw";
import updateSubscriptionPlanContent from "./updateSubscriptionPlan.graphql?raw";
import updateTenantContent from "./updateTenant.graphql?raw";
import updateUserByAdminContent from "./updateUserByAdmin.graphql?raw";
import updateUserDocumentContent from "./updateUserDocument.graphql?raw";
import uploadUserDocumentContent from "./uploadUserDocument.graphql?raw";
import verifyRegisteredEmailContent from "./verifyRegisteredEmail.graphql?raw";
import verifyUserByTokenContent from "./verifyUserByToken.graphql?raw";
import addSettingKeyContent from "./addSettingKey.graphql?raw";
import deleteSettingKeyContent from "./deleteSettingKey.graphql?raw";
import updateTenantSettingsContent from "./updateTenantSettings.graphql?raw";
import updatePartnerSettingsContent from "./updatePartnerSettings.graphql?raw";
import updateUserSettingsContent from "./updateUserSettings.graphql?raw";
import uploadTranslationZipContent from "./uploadTranslationZip.graphql?raw";
import submitFeedbackContent from "./submitFeedback.graphql?raw";

// Export all mutations
export const mutations = {
  submitFeedback: gql(submitFeedbackContent),
  uploadTranslationZip: gql(uploadTranslationZipContent),
  updateUserSettings: gql(updateUserSettingsContent),
  updateTenantSettings: gql(updateTenantSettingsContent),
  updatePartnerSettings: gql(updatePartnerSettingsContent),
  addSettingKey: gql(addSettingKeyContent),
  deleteSettingKey: gql(deleteSettingKeyContent),
  addCompanyToTenant: gql(addCompanyToTenantContent),
  addCustomerUser: gql(addCustomerUserContent),
  addDataLimit: gql(addDataLimitContent),
  addDeal: gql(addDealContent),
  addMeterData: gql(addMeterDataContent),
  addModule: gql(addModuleContent),
  addPartner: gql(addPartnerContent),
  addRole: gql(addRoleContent),
  addSubscriptionFeature: gql(addSubscriptionFeatureContent),
  addSubscriptionPlan: gql(addSubscriptionPlanContent),
  addTenant: gql(addTenantContent),
  addUserByAdmin: gql(addUserByAdminContent),
  addUserToPartner: gql(addUserToPartnerContent),
  addUserToTenant: gql(addUserToTenantContent),
  changePasswordMutatiion: gql(changePasswordMutatiionContent),
  deleteAllNotifications: gql(deleteAllNotificationsContent),
  deleteDataLimit: gql(deleteDataLimitContent),
  deleteDeal: gql(deleteDealContent),
  deleteModule: gql(deleteModuleContent),
  deleteNotification: gql(deleteNotificationContent),
  deletePublicToken: gql(deletePublicTokenContent),
  deleteRole: gql(deleteRoleContent),
  deleteSubscriptionFeature: gql(deleteSubscriptionFeatureContent),
  deleteSubscriptionPlan: gql(deleteSubscriptionPlanContent),
  deleteTenant: gql(deleteTenantContent),
  deleteUserDocument: gql(deleteUserDocumentContent),
  deleteUsersCustomerAdmin: gql(deleteUsersCustomerAdminContent),
  forgotPassword: gql(forgotPasswordContent),
  generatePublicToken: gql(generatePublicTokenContent),
  login: gql(loginContent),
  loginAs: gql(loginAsContent),
  notifyNotification: gql(notifyNotificationContent),
  readAllNotifications: gql(readAllNotificationsContent),
  readNotification: gql(readNotificationContent),
  unreadNotification: gql(unreadNotificationContent),
  redirectStats: gql(redirectStatsContent),
  register: gql(registerContent),
  removeCompanyFromTenant: gql(removeCompanyFromTenantContent),
  removeUserFromPartner: gql(removeUserFromPartnerContent),
  removeUserFromTenant: gql(removeUserFromTenantContent),
  resetPassword: gql(resetPasswordContent),
  sendWelcomeEmail: gql(sendWelcomeEmailContent),
  updateCurrentUserProfile: gql(updateCurrentUserProfileContent),
  updateDataLimit: gql(updateDataLimitContent),
  updateDeal: gql(updateDealContent),
  updateModule: gql(updateModuleContent),
  updatePartner: gql(updatePartnerContent),
  updateRole: gql(updateRoleContent),
  updateRoleModules: gql(updateRoleModulesContent),
  updateSettings: gql(updateSettingsContent),
  updateSubscriptionFeature: gql(updateSubscriptionFeatureContent),
  updateSubscriptionPlan: gql(updateSubscriptionPlanContent),
  updateTenant: gql(updateTenantContent),
  updateUserByAdmin: gql(updateUserByAdminContent),
  updateUserDocument: gql(updateUserDocumentContent),
  uploadUserDocument: gql(uploadUserDocumentContent),
  verifyRegisteredEmail: gql(verifyRegisteredEmailContent),
  verifyUserByToken: gql(verifyUserByTokenContent),
  addCompany: gql(addCompanyContent),
  updateCompany: gql(updateCompanyContent),
  deleteCompany: gql(deleteCompanyContent),
};
